import styled from '@emotion/styled'
import { ScrollList } from '@hhgtech/hhg-components/components'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

import { PhoneInput } from '../phoneInput'

export const StyledWorkshopForm = styled.div``

export const StyledWorkshopHeading = styled.div`
  border-bottom: 1px solid ${theme.colors.neutral100};
`

export const StyledWorkshopTitle = styled.p`
  padding-bottom: 8px;
  color: ${theme.colors.secondaryBase};
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
`

export const StyledWorkshopBody = styled.div`
  padding: 24px 0;
  ${MediaQueries.mbDown} {
    max-height: calc(100vh - 200px);
    overflow: hidden auto;
  }
`

export const StyledLabel = styled.label`
  display: block;
  margin-bottom: 6px;
  color: ${theme.colors.gray600};
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
`

export const StyledInput = styled.input`
  padding: 12px 16px;
  border: 1px solid #d9d9d9;
  margin: 0 0 16px 0;
  border-radius: ${theme.borderRadius};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`

export const StyledScrollList = styled(ScrollList)`
  ${MediaQueries.mbUp} {
    .arrow-right {
      right: -10px;
      cursor: pointer;
      svg {
        fill: white;
      }
    }
    .arrow-left {
      left: -10px;
      cursor: pointer;
      svg {
        fill: white;
      }
    }
  }
`

export const StyledPhoneInput = styled(PhoneInput)`
  margin-bottom: 16px;
`

export const StyledSubmitButton = styled.button`
  padding: 12px 24px;
  margin-top: 32px;
  background: ${theme.colors.primaryBase};
  border-radius: ${theme.borderRadius};
  color: ${theme.colors.white};
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  &[disabled] {
    background: ${theme.colors.neutral500};
    cursor: not-allowed;
  }
`
